import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";
import { CategoryTypes, ListResponse, Subject, CreateSubjectDto, GetSubjectDto } from "../../interfaces";
import { toastMessage } from "../../utils/toastError";

export const subjectApi = createApi({
  reducerPath: "subjectApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/subject",
    credentials: "include",
  }),
  endpoints: (build) => ({
    getSubjects: build.query<ListResponse<Subject>, GetSubjectDto | void>({
      query: (params) => ({
        url: "/",
        method: "GET",
        params: params ? params : {},
      }),
    }),
    createSubject: build.mutation<Subject, CreateSubjectDto>({
      query: (payload) => ({
        url: "/",
        method: "POST",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue: Subject) {
        toastMessage("success", "Successfully created");
        return baseQueryReturnValue;
      },
    }),
    updateSubject: build.mutation<CategoryTypes, { id: string; name: string }>({
      query: (payload) => ({
        url: "/",
        method: "PUT",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
    }),
    deleteSubject: build.mutation<any, string | number>({
      query: (id) => ({
        url: "/",
        method: "DELETE",
        body: { id },
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue) {
        toastMessage("success", "Successfully deleted");
        return baseQueryReturnValue;
      },
    }),
  }),
});

export const {
  useCreateSubjectMutation,
  useUpdateSubjectMutation,
  useDeleteSubjectMutation,
  useGetSubjectsQuery,
  useLazyGetSubjectsQuery,
} = subjectApi;
